import { InjectionToken, inject } from '@angular/core'

import { Observable, shareReplay } from 'rxjs'

import { AuthApiService } from '@flowx/designer/shared/api/auth.api'

import { EnvironmentDefinition } from './auth.types'

// environment definition
export const FX_ENVIRONMENT_DEFINITION = new InjectionToken<Observable<EnvironmentDefinition>>(
  'FX_ENVIRONMENT_DEFINITION',
  {
    providedIn: 'root',
    factory: () =>
      inject(AuthApiService)
        .getEnvironmentDefinition()
        .pipe(shareReplay({ bufferSize: 1, refCount: false })),
  }
)
